import { z } from "zod";
// The age bracket a feedback form is served for (ADR-023 Decision 1). Resolved
// from the client's age at invitation time (a later slice); adult is the
// default/fallback and today's only served form.
export const BracketSchema = z.enum(["adult", "teen", "child"]);
